import Api from "../axios"

export const getGroupId=async()=>{
    return await Api.get('Group/GetGroups')
}